import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CloseIcon } from '@/components/UI/Icons/Icons';

export const ModalContent = styled.div`
  display: grid;
  gap: 20px;
  padding: 40px 50px;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const ModalTitle = styled(Typography.Header)`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 22px;
  font-weight: 700;
`;

export const CloseButton = styled(Button).attrs({
  appearance: 'transparent',
  hasPadding: false,
})`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const CloseButtonIcon = styled(CloseIcon).attrs(({ theme }) => ({
  width: 15,
  height: 15,
  fill: theme.palette.secondary.labels,
}))``;

export const Content = styled.div`
  display: grid;
  gap: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 15px 0 50px 0;
  }
`;

export const CodeInputsContainer = styled.div``;

export const CodeInputs = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const CodeInput = styled.input`
  width: 60px;
  height: 60px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.quartenary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 30px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.palette.brand.main};
  }

  &:disabled {
    color: ${({ theme }) => theme.palette.secondary.labels};
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    height: 50px;
  }
`;

export const ErrorText = styled(Typography.Text)`
  display: block;
  color: ${({ theme }) => theme.palette.system.red};
  margin-top: 5px;
`;

export const TimerText = styled(Typography.Text)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;
  font-size: 15px;
`;

export const TimerAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 18px;
`;

export const ResendButton = styled.button`
  width: fit-content;
  padding: 0;
  border: 0;
  background: none;
  color: ${({ theme }) => theme.palette.brand.main};
  font: inherit;
  font-size: 15px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.palette.system.deepOrange};
    }
  }
`;
